import axiosInstance from './../axiosInstance';

/**
 * Get mobile settings for event.
 *
 * @param {string} eventID
 */
export const getEventMobileSettings = eventID => {
    // var URL = "events/" + this.props.match.params.eventID + "/mobileSettings"
  return axiosInstance.get(`events/${eventID}/mobileSettings`);
};
